import { isNil } from "lodash";
import { RefreshMatch } from "PFApp/components/refresh_match";
import { Typography } from "PFComponents/typography";
import { getMatchDisplayValue } from "PFCore/helpers/match_value";
import React from "react";
import { useTranslation } from "react-i18next";

import { useRefreshMatch } from "../../../hooks/use_refresh_match";
import { MatchedPreferences } from "../../matched_preferences";
import { RoleCardProps } from "../role_card";
import css from "../role_card.module.scss";

type RoleCardDetailsProps = Pick<RoleCardProps, "role">;

export const RoleCardDetails = ({ role }: RoleCardDetailsProps) => {
  const { t: marketplaceT } = useTranslation("marketplace", {
    keyPrefix: "workOpportunities.roleCard.details"
  });
  const { onRefreshSuccess } = useRefreshMatch(role.id);

  const hasNormalizedScore = !isNil(role.scores?.normalized_score);
  const hasAvailabilityScore = !isNil(role.scores?.availability_score);

  return (
    <div className={css.details}>
      <div className={css.detailsRow}>
        {hasNormalizedScore && (
          <div className={css.detailsField}>
            <Typography variant="labelRegular">{marketplaceT("match")}</Typography>
            <span className={css.matchScore}>
              <Typography variant="bodyButtons" className={css.detailsValue} noMargin>
                {getMatchDisplayValue(role.scores?.normalized_score, { showPercentage: true })}
              </Typography>
              <RefreshMatch activity={role.activity} onSuccess={onRefreshSuccess} />
            </span>
          </div>
        )}
        {hasAvailabilityScore && (
          <div className={css.detailsField}>
            <Typography variant="labelRegular">{marketplaceT("availability")}</Typography>
            <Typography variant="bodyButtons" noMargin className={css.detailsValue}>
              {getMatchDisplayValue(role.scores?.availability_score, { showPercentage: true })}
            </Typography>
          </div>
        )}
      </div>
      <MatchedPreferences matches={role.activity.matched_by} />
    </div>
  );
};
